import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const EmptyStateAction = ({
  description,
  actionText,
  onAction,
  children,
  rootSx,
  descriptionSx,
  buttonProps,
}) => {
  return (
    <Box
      sx={{
        minHeight: 56,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        ...rootSx,
      }}
    >
      <Box
        display="flex"
        justifyContent="center"
        width="100%"
        p={4}
        sx={descriptionSx}
      >
        <Typography>{description}</Typography>
      </Box>
      {children || (
        <Button
          variant="contained"
          color="success"
          size="medium"
          onClick={onAction}
          startIcon={<AddIcon />}
          {...buttonProps}
        >
          {actionText}
        </Button>
      )}
    </Box>
  );
};

export default EmptyStateAction;
